import React from 'react';
import { upperCaseWordSplitAndSpace } from '../../../utils/regex.utils';
import './styles.scss';

const EmptyApiDataMessage = ({ componentName = '' }) => {
  const formattedName = upperCaseWordSplitAndSpace(componentName);

  return (
    <section className="emptyApiDataMessage">
      <p className="emptyApiDataMessage__title">{formattedName} data missing</p>
    </section>
  );
};

export default EmptyApiDataMessage;
